module.exports = __webpack_public_path__ + "static/media/Roses.dc328e49.webp";